<section class="comparative-analysis-section">
  <nz-tabset
    [nzType]="'card'"
    [(nzSelectedIndex)]="selectedTabIndex"
    (nzSelectedIndexChange)="handleTabChange($event)"
  >
    <nz-tab [nzTitle]="tabList.trend.label" class="comparative-tab">
      <ng-container *ngIf="initializedTabs[0]">
        <app-comparative-trend
          [isActive]="selectedTabIndex === 0"
          [state]="trendCompState"
          [shouldFetchData]="shouldFetchTrendData"
          [recentlyVisitedCompanies]="recentlyVisitedCompanies"
          [watchlistData]="watchlistData"
          [industryMenuData]="industryMenuData"
          [marketGeoData]="marketGeoData"
          [suggestedPeers]="suggestedPeers"
          [sortByColumnId]="sortByColumnId"
          [tickerModalDataReady]="
            !suggestedPeersApiInProgress &&
            !isWatchlistMenuApiInProgress &&
            !recentlyVisitedCompanyInProgress
          "
          [lineItemsData]="trendCompLineItemsData"
          [isStdLineItemsUpdateInProgress]="isStdLineItemsUpdateInProgress"
          (updateUnsavedDataStatus)="updateUnsavedDataStatus()"
          (updateTrendState)="updateTrendCompState($event)"
          (updateGridSortByColumnId)="updateGridSortByColumnId()"
          (onDataFetchInitiate)="onTrendDataFetchInitiate()"
          (initiateWatchlistFetch)="getwatchlistData()"
          (updateTrendStateWithoutMakingDataCalls)="
            updateTrendCompStateWithoutMakingDataCalls($event)
          "
          (onFetchLineitemData)="fetchAndUpdateStdLineItems($event)"
        ></app-comparative-trend>
      </ng-container>
    </nz-tab>
    <nz-tab [nzTitle]="tabList.comparision.label" class="comparative-tab">
      <ng-container *ngIf="initializedTabs[1]">
        <app-comparative-comparision
          [isActive]="selectedTabIndex === 1"
          [state]="trendCompState"
          [shouldFetchData]="shouldFetchComparisionData"
          [recentlyVisitedCompanies]="recentlyVisitedCompanies"
          [watchlistData]="watchlistData"
          [industryMenuData]="industryMenuData"
          [marketGeoData]="marketGeoData"
          [suggestedPeers]="suggestedPeers"
          [tickerModalDataReady]="
            !suggestedPeersApiInProgress &&
            !isWatchlistMenuApiInProgress &&
            !recentlyVisitedCompanyInProgress
          "
          [lineItemsData]="trendCompLineItemsData"
          [isStdLineItemsUpdateInProgress]="isStdLineItemsUpdateInProgress"
          [sortByColumnId]="sortByColumnId"
          (updateGridSortByColumnId)="updateGridSortByColumnId()"
          (updateUnsavedDataStatus)="updateUnsavedDataStatus()"
          (updateCompState)="updateTrendCompState($event)"
          (onDataFetchInitiate)="onComparisionDataFetchInitiate()"
          (initiateWatchlistFetch)="getwatchlistData()"
          (onFetchLineitemData)="fetchAndUpdateStdLineItems($event)"
        ></app-comparative-comparision>
      </ng-container>
    </nz-tab>
    <nz-tab [nzTitle]="tabList.revision.label" class="comparative-tab">
      <ng-container *ngIf="initializedTabs[2]">
        <app-comparative-revi-sur
          [isActive]="selectedTabIndex === 2"
          tabType="Revision"
          [state]="revisionState"
          [shouldFetchData]="shouldFetchRevisionData"
          [routeParams]="routeParams"
          [routeQueryParams]="routeQueryParams"
          [pageType]="pageType"
          [compType]="compType"
          [compId]="compId"
          [recentlyVisitedCompanies]="recentlyVisitedCompanies"
          [watchlistData]="watchlistData"
          [industryMenuData]="industryMenuData"
          [marketGeoData]="marketGeoData"
          [suggestedPeers]="suggestedPeers"
          [sortByColumnId]="sortByColumnId"
          [tickerModalDataReady]="
            !suggestedPeersApiInProgress &&
            !isWatchlistMenuApiInProgress &&
            !recentlyVisitedCompanyInProgress
          "
          (updateUnsavedDataStatus)="updateUnsavedDataStatus()"
          (updateRevSupState)="updateRevisionState($event)"
          (updateGridSortByColumnId)="updateGridSortByColumnId()"
          (onDataFetchInitiate)="onRevisionDataFetchInitiate()"
          (initiateWatchlistFetch)="getwatchlistData()"
          (onFetchLineitemData)="fetchAndUpdateStdLineItems($event)"
        ></app-comparative-revi-sur>
      </ng-container>
    </nz-tab>
    <nz-tab [nzTitle]="tabList.surprise.label" class="comparative-tab">
      <ng-container *ngIf="initializedTabs[3]">
        <app-comparative-revi-sur
          [isActive]="selectedTabIndex === 3"
          tabType="Surprise"
          [state]="surpriseState"
          [shouldFetchData]="shouldFetchSurpriseData"
          [routeParams]="routeParams"
          [routeQueryParams]="routeQueryParams"
          [pageType]="pageType"
          [compType]="compType"
          [compId]="compId"
          [recentlyVisitedCompanies]="recentlyVisitedCompanies"
          [watchlistData]="watchlistData"
          [industryMenuData]="industryMenuData"
          [marketGeoData]="marketGeoData"
          [suggestedPeers]="suggestedPeers"
          [sortByColumnId]="sortByColumnId"
          [tickerModalDataReady]="
            !suggestedPeersApiInProgress &&
            !isWatchlistMenuApiInProgress &&
            !recentlyVisitedCompanyInProgress
          "
          (updateUnsavedDataStatus)="updateUnsavedDataStatus()"
          (updateRevSupState)="updateSurpriseState($event)"
          (updateGridSortByColumnId)="updateGridSortByColumnId()"
          (onDataFetchInitiate)="onSurpriseDataFetchInitiate()"
          (initiateWatchlistFetch)="getwatchlistData()"
          (onFetchLineitemData)="fetchAndUpdateStdLineItems($event)"
        ></app-comparative-revi-sur>
      </ng-container>
    </nz-tab>
    <nz-tab [nzTitle]="tabList.valuation.label" class="comparative-tab">
      <ng-container *ngIf="initializedTabs[4]">
        <app-comparative-valuation
          [isActive]="selectedTabIndex === 4"
          [state]="valuationState"
          [shouldFetchData]="shouldFetchValuationData"
          [routeParams]="routeParams"
          [routeQueryParams]="routeQueryParams"
          [pageType]="pageType"
          [compType]="compType"
          [watchlistData]="watchlistData"
          [industryMenuData]="industryMenuData"
          [marketGeoData]="marketGeoData"
          [recentlyVisitedCompanies]="recentlyVisitedCompanies"
          [suggestedPeers]="suggestedPeers"
          [compId]="compId"
          [sortByColumnId]="sortByColumnId"
          [tickerModalDataReady]="
            !suggestedPeersApiInProgress &&
            !isWatchlistMenuApiInProgress &&
            !recentlyVisitedCompanyInProgress
          "
          (updateUnsavedDataStatus)="updateUnsavedDataStatus()"
          (updateValuationState)="updateValuationState($event)"
          (updateGridSortByColumnId)="updateGridSortByColumnId()"
          (onDataFetchInitiate)="onValuationDataFetchInitiate()"
          (initiateWatchlistFetch)="getwatchlistData()"
        ></app-comparative-valuation>
      </ng-container>
    </nz-tab>
    <nz-tab [nzTitle]="tabList.tpr.label" class="comparative-tab">
      <ng-container *ngIf="initializedTabs[5]">
        <app-comparative-tpr
          [isActive]="selectedTabIndex === 5"
          [state]="tprState"
          [shouldFetchData]="shouldFetchTprData"
          [routeParams]="routeParams"
          [routeQueryParams]="routeQueryParams"
          [pageType]="pageType"
          [compType]="compType"
          [watchlistData]="watchlistData"
          [industryMenuData]="industryMenuData"
          [marketGeoData]="marketGeoData"
          [recentlyVisitedCompanies]="recentlyVisitedCompanies"
          [suggestedPeers]="suggestedPeers"
          [compId]="compId"
          [sortByColumnId]="sortByColumnId"
          [tickerModalDataReady]="
            !suggestedPeersApiInProgress &&
            !isWatchlistMenuApiInProgress &&
            !recentlyVisitedCompanyInProgress
          "
          (updateUnsavedDataStatus)="updateUnsavedDataStatus()"
          (updateGridSortByColumnId)="updateGridSortByColumnId()"
          (updateTprState)="updateTprState($event)"
          (onDataFetchInitiate)="onTprDataFetchInitiate()"
          (initiateWatchlistFetch)="getwatchlistData()"
        ></app-comparative-tpr>
      </ng-container>
    </nz-tab>
    <nz-tab [nzTitle]="tabList.charts.label" class="comparative-tab">
      <ng-container *ngIf="initializedTabs[6]">
        <app-comparative-charts
          [isActive]="selectedTabIndex === 6"
          [trendState]="chartsTrendState"
          [comparisonState]="chartsComparisonState"
          [revisionState]="chartsRevisionState"
          [routeParams]="routeParams"
          [shouldFetchData]="shouldFetchChartsData"
          [routeQueryParams]="routeQueryParams"
          [pageType]="pageType"
          [compType]="compType"
          [compId]="compId"
          [marketGeoData]="marketGeoData"
          [watchlistData]="watchlistData"
          [recentlyVisitedCompanies]="recentlyVisitedCompanies"
          [suggestedPeers]="suggestedPeers"
          [tickerModalDataReady]="
            !suggestedPeersApiInProgress &&
            !isWatchlistMenuApiInProgress &&
            !recentlyVisitedCompanyInProgress
          "
          [industryMenuData]="industryMenuData"
          (updateGridSortByColumnId)="updateGridSortByColumnId()"
          (updateUnsavedDataStatus)="updateUnsavedDataStatus()"
          (updateChartState)="updateChartState($event)"
          (onDataFetchInitiate)="onChartDataFetchInitiate()"
          (initiateWatchlistFetch)="getwatchlistData()"
          (isDownloadingInProgress)="updateDownloadStatus($event)"
        ></app-comparative-charts>
      </ng-container>
    </nz-tab>
  </nz-tabset>
</section>
